// extracted by mini-css-extract-plugin
export default {"Container":"BranchActionMenu-module__Container__IqKm6fS","ActionButtonGroup":"BranchActionMenu-module__ActionButtonGroup__Jv_oupd"};